/**
 * Public offer page route — /public/offers/:token (exact match)
 *
 * Anonymous (no-auth) route. Renders PublicOfferPage with the URL token.
 * Split out of `$token.tsx` (now a pure layout route with `<Outlet />`) so the
 * sibling `$token.units.$unitId.tsx` child route actually renders — TanStack
 * Router requires the parent segment (`$token.tsx`) to render an `<Outlet />`
 * for any nested route to display at all (client-offer-unit-detail-page /
 * CU-86cbde3ae).
 *
 * Traceability: public-offer-client-link / Requirement: Public Offer Page
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PublicOfferPage } from '@ooh/screens';

export const Route = createFileRoute('/public/offers/$token/')({
  component: PublicOfferRoute,
});

function PublicOfferRoute() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  return (
    <PublicOfferPage
      token={token}
      onOpenUnitDetail={(mediaUnitId) =>
        void navigate({
          to: '/public/offers/$token/units/$unitId',
          params: { token, unitId: String(mediaUnitId) },
        })
      }
    />
  );
}
